export type TSmetterModuleSource = 'crm' | 'construction';

export type TCrmModuleSwitcherProps = {
    source: 'crm';
};

export type TConstructionModuleSwitcherProps = {
    source: 'construction';
    canUseCrmByTariff: boolean;
    canUseCrmByEmployee: boolean;
    tariffModalUrl?: string;
    tariffModalContent?: string;
};

export type TSmetterModuleSwitcherProps =
    | TCrmModuleSwitcherProps
    | TConstructionModuleSwitcherProps;

export type TCrmAccessState = 'available' | 'tariff-restricted' | 'hidden';

type TGetCrmAccessStateParams = {
    canUseCrmByTariff: boolean;
    canUseCrmByEmployee: boolean;
};

export const getCrmAccessState = ({
    canUseCrmByTariff,
    canUseCrmByEmployee,
}: TGetCrmAccessStateParams): TCrmAccessState => {
    if (!canUseCrmByTariff) return 'tariff-restricted';
    if (!canUseCrmByEmployee) return 'hidden';

    return 'available';
};

export const getTargetModuleRoute = (source: TSmetterModuleSource) =>
    source === 'crm' ? '/' : '/crm';
